// Lazy-load with stale-chunk recovery. After a redeploy, an open tab may
// request an old hashed chunk that no longer exists (ChunkLoadError). On the
// first failure we force one full reload to pick up the new build; if it
// still fails (real error), we let it throw.
import { lazy } from "react";

export function lazyRetry(importFn) {
  return lazy(() =>
    importFn().catch((err) => {
      const key = "chunk_reload_" + (window.location.pathname || "/");
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, "1");
        window.location.reload();
        return new Promise(() => {});
      }
      sessionStorage.removeItem(key);
      throw err;
    }).then((mod) => {
      sessionStorage.removeItem("chunk_reload_" + (window.location.pathname || "/"));
      return mod;
    })
  );
}
